import React from 'react';
import { IPickPackList } from 'interfaces/pickPackList';
import './index.scss';
import _ from 'lodash';
import Currency from 'components/Currency/Currency';
import { CATEGORIES_FOR_PICK_PACK_LIST, formatAddress, inventoryItemAddressRangeFormat } from 'utils';

type IPDFDataProps = {
  pdfData: IPickPackList.IPickPackPDFData;
}

const getRouteEarning = (pickPackRouteId, routes) => {
  let routeEarning = 0;
  _.forEach(routes, (route) => {
    if (route.objectId === pickPackRouteId) {
      routeEarning = _.get(route, 'routeEarning', 0);
    }
  });
  return parseFloat(routeEarning.toFixed(2));
};

const PickPackPDF: React.FC<IPDFDataProps> = props => {
  const {
    pickPackId,
    pickPackName,
    routes,
    itemMap,
    routeAndOrderDetails,
  } = props.pdfData;

  const pageByCategory = () => {
    return {
      vegetales: itemMap.filter((x) => x.category === CATEGORIES_FOR_PICK_PACK_LIST.VEGETALES),
      frutas: itemMap.filter((x) => x.category === CATEGORIES_FOR_PICK_PACK_LIST.FRUTAS),
      tuberculos: itemMap.filter((x) => x.category === CATEGORIES_FOR_PICK_PACK_LIST.TUBERCULOS),
      hojas: itemMap.filter((x) => x.category === CATEGORIES_FOR_PICK_PACK_LIST.HOJAS),
      hierbas: itemMap.filter((x) => x.category === CATEGORIES_FOR_PICK_PACK_LIST.HIERBAS),
    };
  };

  const getCategoryPage = ({ items, title, category }) => {
    return (
      <div className={'order-item-count-list'}>
        <div className={'row ml-0 mr-0'}>
          <div className={'col-12 pl-0'}>
            <h5>{title}</h5>
            <table
              id={'orderCountDetailModalTable'}
              className={'center table table-striped table-bordered'}
              style={{ width: '100%' }}
            >
              <thead>
                <tr>
                  <th colSpan={5}>{category}</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Unit</th>
                  <th>Count</th>
                  <th>Slot No</th>
                  <th>Packaging Type</th>
                </tr>
              </thead>
              <tbody>
                {items.map(item => (
                  <tr key={item.objectId}>
                    <td>{item.name}</td>
                    <td>{item.unit}</td>
                    <td>{item.count}</td>
                    <td>{item.slotNo}</td>
                    <td>{item.packagingType}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={'m-5'}>
      <div className={'row ml-0 mr-0'}>
        <div className={'col-7 pl-0'}>
          <div className={'d-flex'}>
            <label>Pick Pack Id:</label>
            <h5 id={'pickPackId'} className={'pl-2'}>{pickPackId}</h5>
          </div>
        </div>
        <div className={'col-5 d-flex'}>
          <label id={''}>Pick Pack Name: </label>
          <p id={'pickPackName'} className={'pl-2'}>{pickPackName}</p>
        </div>
      </div>

      <h5>Routes</h5>

      <table
        id={'pickPackRouteTable'}
        className={'center table table-striped table-bordered'}
        style={{ width: '95vw' }}
      >
        <thead>
          <tr>
            <th>Object Id</th>
            <th>Name</th>
            <th>Earning</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {routes.map(route => (
            <tr key={route.objectId}>
              <td>{route.objectId}</td>
              <td>{route.name}</td>
              <td>{route.routeEarning}</td>
              <td>{route.status}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* add bottom margin */}

      <div className={'order-item-count-list'}>
        <div className={'row ml-0 mr-0'}>
          <div className={'col-12 pl-0'}>
            <h5>Order Item Counts</h5>
            <table
              id={'orderCountDetailModalTable'}
              className={'center table table-striped table-bordered'}
              style={{ width: '95vw' }}
            >
              <thead>
                <tr>
                  <th>Object Id</th>
                  <th>Slot No</th>
                  <th>Name</th>
                  <th>Item Address</th>
                  <th>Category</th>
                  <th>Image</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {itemMap.map(item => (
                  <tr key={item.objectId}>
                    <td>{item.objectId}</td>
                    <td>{item.slotNo}</td>
                    <td>{item.name}</td>
                    <td>{item.inventoryAddress ? inventoryItemAddressRangeFormat(item.inventoryAddress) : '-'}</td>
                    <td>{item.category}</td>
                    <td>
                      <img
                        className={'sized-image'}
                        src={item.image}
                      />
                    </td>
                    <td>{`${item.count} ${item.unit}`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {routeAndOrderDetails.map(record => (
        <div key={record.pickPackRouteId}>
          <h4 className={'break-before'}>{`Route Id: ${record.pickPackRouteId}`}</h4>
          <h5 className={''}>
            <span>{`Earning: `}</span>
            <Currency amount={getRouteEarning(record.pickPackRouteId, routes)} />
          </h5>
          <hr className={'mt-2 mb-2'} />
          <div className={'route-orders-list'}>
            <div className={'row ml-0 mr-0'}>
              <div className={'col-12 pl-0'}>
                <h5>Orders</h5>
                <table
                  id={'pickPackListRouteOrdersTable'}
                  className={'center table table-striped table-bordered'}
                  style={{ width: '95vw',tableLayout: 'fixed' }}
                >
                  <thead>
                    <tr>
                      <th>Object Id</th>
                      <th>Status</th>
                      <th>Customer Detail</th>
                      <th>Notes</th>
                      <th>Delivery Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    {record.routeOrders.map(routeOrder => (
                      <tr key={routeOrder.objectId}>
                        <td>{routeOrder.objectId}</td>
                        <td>{routeOrder.status}</td>
                        <td style={{ minWidth: '400px',wordWrap: 'break-word' }}>
                          <p>
                            <label className={'font-weight-bold'}>Name: </label>
                            <span>{routeOrder.customerDetail.purchaser}</span>
                          </p>
                          {routeOrder.customerDetail.phone ? (
                            <p>
                              <label className={'font-weight-bold'}>Phone: </label>
                              <span>{routeOrder.customerDetail.phone}</span>
                            </p>
                          ) : null}
                          {routeOrder.customerDetail.address ? (
                            <p>
                              <label className={'font-weight-bold'}>Address: </label>
                              <span>{formatAddress(routeOrder.customerDetail)}</span>
                            </p>
                          ) : null}
                        </td>
                        <td
                          style={{ wordWrap: 'break-word' }}
                        >{routeOrder.notes}</td>
                        <td
                          style={{ minWidth: '100%' }}
                        >
                          <img
                            className={'sized-image'}
                            src={routeOrder.qrCode}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <h4 className={'break-before'}>Orders Details</h4>
          {record.orderDetails.map(order => (
            <div className={'order-detail break-after'} key={order.objectId}>
              <div className={'row ml-0 mr-0'}>
                <div className={'col-7 pl-0'}>
                  <strong>Order Id: </strong>{order.objectId}
                  {order.showDangerFlag ? (
                    <i className={'fa fa-exclamation-triangle text-danger pl-4'}></i>
                  ) : null}
                </div>
                <div className={'col-5 justify-content-end pr-0 text-right'}>
                  {order.status}<br /><strong>{order.total}</strong>
                </div>
              </div>
              <div className={'d-flex justify-content-between mt-2'}>
                <div className={'col-8'}>
                  <h5>Customer Details</h5>
                  <strong>Name: </strong>{order.name}<br />
                  <strong>Phone: </strong>{order.phone}<br />
                  <strong>Address: </strong>{formatAddress(order)}<br />
                  <strong>Notes: </strong>{order.notes}<br />
                </div>
                <div className={'col-2 d-flex justify-content-end align-items-center p-0'}>
                  <img
                    alt={'qr-code'}
                    src={order.qrCode}
                    className={'sized-image'}
                  />
                </div>
              </div>
              <br />
              <h5>Items</h5>
              {/* {order.categoryItems.map((categoryItem, i) => ( */}
              <div className={'mb-4'}>
                {/* <div className={'row align-content-center'}>
                  <div className={'col-9 d-flex align-content-center'}>
                    <h5 className={'text-secondary pr-4'}>{categoryItem.category}</h5> */}
                {/* <!-- find a solution --> */}
                {/* <!-- <span className='category-dot' style='background-color: {{this.category.color}}'></span> --> */}
                {/* </div>
                </div> */}
                <table className={'table table-striped table-bordered'}
                  style={{ width: '95vw' }}
                >
                  <thead>
                    <tr>
                      <th>Slot No</th>
                      <th>Name</th>
                      <th>Item Address</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Refunded Quantity</th>
                      <th>Unit</th>
                      <th>Image</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.items.map((item, i) => (
                      <tr key={i}>
                        <td>{item.slotNo}</td>
                        <td>{item.name}</td>
                        <td>{item.inventoryAddress ? inventoryItemAddressRangeFormat(item.inventoryAddress) : '-'}</td>
                        <td><Currency amount={item.price} /></td>
                        <td>{item.count}</td>
                        <td>{item.refundedCount || '0'}</td>
                        <td>{item.description}</td>
                        <td>
                          <img
                            className={'sized-image'}
                            src={item.imageURL}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* ))} */}
            </div>
          ))}
        </div>
      ))}
      {getCategoryPage({ items: pageByCategory().frutas, title: 'ESTACIÓN FRUTA', category: CATEGORIES_FOR_PICK_PACK_LIST.FRUTAS })}
      {getCategoryPage({ items: pageByCategory().hojas, title: 'HOJAS', category: CATEGORIES_FOR_PICK_PACK_LIST.HOJAS })}
      {getCategoryPage({ items: pageByCategory().vegetales, title: 'VEGETALES', category: CATEGORIES_FOR_PICK_PACK_LIST.VEGETALES })}
      {getCategoryPage({ items: pageByCategory().tuberculos, title: 'TUBERCULOS Y CALABAZA', category: CATEGORIES_FOR_PICK_PACK_LIST.TUBERCULOS })}
      {getCategoryPage({ items: pageByCategory().hierbas, title: 'HIERBAS', category: CATEGORIES_FOR_PICK_PACK_LIST.HIERBAS })}
    </div>
  );
};

export default PickPackPDF;